
import mainMenuBar from './modules/main-menu.js'
import { headerMenu, quickAccess, logIn, headerContact } from './modules/modal.js'
import headerMenuHandler from './modules/header-menu.js'
import size from './modules/size.js'
import accordion from './modules/accordion.js'
import { api } from './modules/api.js'
import regards from './modules/regards'
import play from './modules/play'
import apiFormBehavior from './api-search/behavior.js'
import setApiSearchForm from './api-search/set-api-search-form.js'
import getCoordinatorsLists from './modules/coordinators-list.js'
import exerptHandler from './modules/exerpt-handler.js'
import accessibility from './modules/accessibility'
import leaveDetails from './modules/leave-details'

/** API */
import buildQuery from './api-search/build-query.js'
//import './modules/fix'
import { projectsSlider, heroSlider } from './modules/sliders.js'
document.addEventListener('DOMContentLoaded', () => {






  // Header menu bar shrink
  mainMenuBar()

  // menu items slides
  headerMenuHandler()

  // Modals
  quickAccess()
  headerMenu()
  logIn()
  headerContact()

  regards()

  accordion()

  // API
  setApiSearchForm(apiFormBehavior)
  buildQuery()
  api()

  // show coordinators lists
  getCoordinatorsLists()

  exerptHandler()


  // Accessibility
  accessibility()

  // Leave Details
  leaveDetails()


  // playing
  //play()
  // Sliders
  projectsSlider()
  heroSlider()
})



